import React, { useContext } from "react";
import "./WhatsAppFloat.css";
import { Context } from "../../../context/Context";
import { landingContent } from "../content/landingContent";
import config from "../../../config.json";

export const WhatsAppFloat = () => {
  const { lang } = useContext(Context);
  const t = landingContent[lang] || landingContent.en;

  return (
    <a
      className="landing-whatsapp-float"
      href={config.WHATSUP}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp}
      title={t.whatsapp}
    >
      <svg viewBox="0 0 32 32" className="landing-whatsapp-icon" aria-hidden="true">
        <path
          fill="currentColor"
          d="M16.004 2.667c-7.363 0-13.333 5.97-13.333 13.333 0 2.353.615 4.56 1.688 6.474L2.667 29.333l7.06-1.852a13.26 13.26 0 0 0 6.277 1.6h.006c7.362 0 13.333-5.97 13.333-13.333 0-3.56-1.386-6.907-3.903-9.424a13.24 13.24 0 0 0-9.436-3.657Zm0 24.4a11.02 11.02 0 0 1-5.61-1.535l-.402-.24-4.19 1.099 1.12-4.084-.263-.42a11.03 11.03 0 0 1-1.688-5.887c0-6.101 4.966-11.067 11.07-11.067a11 11 0 0 1 7.83 3.24 11 11 0 0 1 3.238 7.83c0 6.103-4.966 11.064-11.104 11.064Zm6.07-8.287c-.332-.166-1.965-.97-2.27-1.08-.305-.111-.527-.166-.749.167-.222.332-.86 1.08-1.054 1.302-.194.222-.388.25-.72.083-.332-.167-1.4-.516-2.667-1.646-.986-.879-1.652-1.966-1.846-2.298-.194-.332-.02-.512.146-.678.15-.15.332-.388.499-.583.166-.194.221-.332.332-.554.111-.222.055-.416-.028-.583-.083-.166-.749-1.804-1.026-2.47-.27-.649-.545-.562-.749-.573l-.638-.011a1.22 1.22 0 0 0-.887.416c-.305.332-1.163 1.137-1.163 2.773 0 1.636 1.19 3.218 1.356 3.44.166.222 2.343 3.578 5.677 5.016.793.343 1.412.548 1.894.701.796.253 1.52.217 2.093.132.639-.095 1.965-.803 2.242-1.58.277-.776.277-1.44.194-1.579-.083-.14-.305-.222-.638-.388Z"
        />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
